module.exports = __webpack_public_path__ + "static/media/risk_management.011d5073.png";